/// <amd-module name="Agile/Common/Components/HubError/HubError" />
import "VSS/LoaderPlugins/Css!Agile/Scripts/Common/Components/AgileHubError";

import { AgileAssetPaths } from "Agile/Assets/AgileAssets";
import { AssetResolver } from "Agile/Common/Components/AssetResolver/AssetResolver";
import { ConfigurationRequired, GeneralErrorTitle } from "Agile/Common/Resources";
import { ExceptionInfo } from "Agile/Contracts/Common";
import { Link } from "VSSUI/Link";
import * as React from "react";
import { ZeroData } from "VSSUI/Components/ZeroData";

export interface IHubErrorProps {
    className?: string;
    exceptionsInfo: ExceptionInfo[];
}

export class HubError extends React.Component<IHubErrorProps, {}> {
    constructor(props: IHubErrorProps) {
        super(props);
    }

    public render(): JSX.Element {
        const exceptionsInfoElement: JSX.Element = (
            <div className={this.props.className}>
                {this.props.exceptionsInfo.map((exceptionInfo, index) => (
                    <div key={index}>
                        {this._getErrorsList(exceptionInfo)}
                        {this._getErrorLinks(exceptionInfo)}
                    </div>
                ))}
            </div>
        );

        const isSettingsException = this.props.exceptionsInfo.some(e => e.isSettingsException || false);

        const imagePath = isSettingsException ? AgileAssetPaths.ConfigurationRequired : AgileAssetPaths.GeneralHubError;
        const errorText = isSettingsException ? ConfigurationRequired : GeneralErrorTitle;

        return (
            <div className="hub-error">
                <AssetResolver assets={[imagePath]}>
                    {([resolvedImagePath]) => (
                        <ZeroData
                            imagePath={resolvedImagePath}
                            imageAltText={errorText}
                            primaryText={errorText}
                            secondaryText={exceptionsInfoElement}
                        />
                    )}
                </AssetResolver>
            </div>
        );
    }

    private _getErrorsList(exceptionInfo: ExceptionInfo): JSX.Element {
        const hasErrorsList: boolean = exceptionInfo.additionalMessages ? exceptionInfo.additionalMessages.length > 0 : false;
        return (
            <div>
                <div>{exceptionInfo.exceptionMessage}</div>
                {hasErrorsList && (
                    <ul>
                        {exceptionInfo.additionalMessages!.map((e, i) => (
                            <li key={`Error${i}`}>{e}</li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }

    private _getErrorLinks(exceptionInfo: ExceptionInfo): JSX.Element {
        let primaryLink: JSX.Element | undefined;
        if (exceptionInfo.primaryLinkHref && exceptionInfo.primaryLinkText) {
            primaryLink = (
                <p>
                    <Link href={exceptionInfo.primaryLinkHref}>{exceptionInfo.primaryLinkText}</Link>
                </p>
            );
        }

        let secondaryLink: JSX.Element | undefined;
        if (exceptionInfo.secondaryLinkHref && exceptionInfo.secondaryLinkText) {
            secondaryLink = (
                <p>
                    <Link href={exceptionInfo.secondaryLinkHref}>{exceptionInfo.secondaryLinkText}</Link>
                </p>
            );
        }

        return (
            <div>
                {primaryLink}
                {secondaryLink}
            </div>
        );
    }
}
